import MainModel from "../../../components/Models/main-model";
import { brandPalette } from "../../../constants/brandPalette";
import {
  Badge,
  Box,
  FormLabel,
  Heading,
  Textarea,
  Button,
  VStack,
  HStack,
  Text,
} from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { closeRefuseHomeworkModel } from "../../../modules/admin-modules/models/Actions";
import { useState, useEffect } from "react";
import { deleteStuentHomeworkRequest } from "../../../modules/admin-modules/reports/Actions";
import { getAssistantsRequest } from "../../../modules/admin-modules/teachersAssistant/Actions";
import Select from "react-select";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
  adminSelectStyles,
} from "../../../components/Models/admin-modal-theme";
import { homeworkSubmissionPdfUrl } from "../../../components/student/PdfPreviewModal";
import HomeworkPdfAnnotator from "./homework-pdf-annotator";

const modalSelectStyles = {
  ...adminSelectStyles(),
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
};

const textareaProps = {
  bg: "var(--surface-muted)",
  color: "var(--text-primary)",
  borderColor: "var(--border-subtle)",
  borderRadius: "14px",
  _placeholder: { color: "var(--text-muted)", opacity: 1 },
  _focus: {
    borderColor: brandPalette.primary,
    boxShadow: "0 0 0 3px rgba(91, 13, 22, 0.12)",
  },
};

const templateChipProps = {
  size: "sm",
  borderRadius: "12px",
  bg: "var(--surface-muted)",
  border: "1px solid",
  borderColor: "var(--border-subtle)",
  color: "var(--text-primary)",
  fontWeight: "800",
  _hover: { bg: "var(--surface-raised)", borderColor: brandPalette.primary },
};

const HomeworkRefuseComment = ({ data, homeworkId }) => {
  const openHomeworkComment = useSelector((state) => state.model.isOpen32);
  const isLoading = useSelector((state) => state.reports.isLoading);
  const [comment, setComment] = useState("");
  const dispatch = useDispatch();
  const assistants = useSelector((state) => state.teacherassistants.assistants);
  const [assistant, setAssistant] = useState("");
  const [assistantComment, setAssistantComment] = useState("");
  const [annotatedFile, setAnnotatedFile] = useState(null);
  const [annotatorOpen, setAnnotatorOpen] = useState(false);
  const assistantsOptions = assistants?.data?.map((a) => {
    return { value: a.id, label: a.name, sign: a.name };
  });

  const pdfUrl = data?.file ? homeworkSubmissionPdfUrl(data.file) : "";

  useEffect(() => {
    dispatch(getAssistantsRequest());
  }, [dispatch]);

  const resetForm = () => {
    setComment("");
    setAssistant("");
    setAssistantComment("");
    setAnnotatedFile(null);
    setAnnotatorOpen(false);
  };

  const header = (
    <Box>
      <Heading textAlign="left" color="var(--text-primary)" fontSize="20px" fontWeight="900">
        Reject submission
      </Heading>
      <Text mt={1} fontSize="sm" fontWeight="700" color="var(--text-muted)">
        Choose a template, annotate the PDF, and write a custom reason.
      </Text>
    </Box>
  );

  const handelAddComment = () => {
    const formData = new FormData();
    formData.append("homework_id", homeworkId || data?.homework?.id);
    formData.append("student_id", data?.student?.id);
    formData.append("evaluation", comment);
    if (assistant) formData.append("assistant_id", assistant);
    if (assistantComment) formData.append("assistant_comment", assistantComment);
    if (annotatedFile) formData.append("file", annotatedFile);

    dispatch(
      deleteStuentHomeworkRequest({
        formData,
        action: () => {
          dispatch(closeRefuseHomeworkModel());
          resetForm();
        },
      })
    );
  };

  const closeFunc = () => {
    dispatch(closeRefuseHomeworkModel());
    resetForm();
  };

  const setEvalation = (evaluation) => () => {
    setComment(evaluation);
    const el = document.getElementById("homework");
    if (el) el.value = evaluation;
  };

  return (
    <>
      <MainModel
        isLoading={isLoading}
        header={header}
        closeFunc={closeFunc}
        openVar={openHomeworkComment}
        buttonTitle={"Save changes"}
        cancelTitle="Cancel"
        buttonFunc={handelAddComment}
        contentProps={adminModalContentProps}
        headerProps={adminModalHeaderProps}
        bodyProps={adminModalBodyProps}
        footerProps={{
          borderTop: "1px solid",
          borderColor: "var(--border-subtle)",
          py: 6,
        }}
      >
        <VStack align="stretch" spacing={5} dir="ltr">
          <HStack justify="space-between" flexWrap="wrap" spacing={3}>
            <Text fontSize="sm" fontWeight="800" color="var(--text-primary)">
              Student:{" "}
              <Text as="span" fontWeight="900">
                {data?.student?.name || "N/A"}
              </Text>
            </Text>
            <Text fontSize="sm" fontWeight="800" color="var(--text-primary)">
              Homework:{" "}
              <Text as="span" fontWeight="900">
                {data?.homework?.name || "N/A"}
              </Text>
            </Text>
            {data?.file ? (
              <HStack spacing={2} flexWrap="wrap">
                <Button
                  as="a"
                  href={pdfUrl}
                  target="_blank"
                  size="sm"
                  borderRadius="12px"
                  bg="var(--surface-muted)"
                  border="1px solid"
                  borderColor="var(--border-subtle)"
                  color="var(--text-primary)"
                  fontWeight="800"
                  _hover={{ bg: "var(--surface-raised)", borderColor: brandPalette.primary }}
                >
                  Open file
                </Button>
                <Button
                  size="sm"
                  borderRadius="12px"
                  bg={brandPalette.primary}
                  color="white"
                  fontWeight="800"
                  _hover={{ bg: brandPalette.accentDark }}
                  onClick={() => setAnnotatorOpen(true)}
                >
                  Annotate PDF
                </Button>
                {annotatedFile ? (
                  <Badge colorScheme="green" borderRadius="full" px={3} py={1}>
                    Annotated PDF ready
                  </Badge>
                ) : null}
              </HStack>
            ) : null}
          </HStack>

          <Box>
            <FormLabel fontWeight="800" color="var(--text-primary)">
              Quick templates
            </FormLabel>
            <HStack w="100%" flexWrap="wrap" spacing={2}>
              <Button
                {...templateChipProps}
                onClick={setEvalation(
                  "Your homework was rejected due to missing steps. Please complete the steps and upload again."
                )}
              >
                Missing steps
              </Button>
              <Button
                {...templateChipProps}
                onClick={setEvalation(
                  "Your homework was rejected because there are many incorrect answers. Please review using the homework video and upload again."
                )}
              >
                Many wrong answers
              </Button>
              <Button
                {...templateChipProps}
                onClick={setEvalation(
                  "Your homework was rejected because the uploaded PDF is not the correct homework. Please upload the correct file."
                )}
              >
                Wrong file
              </Button>
            </HStack>
          </Box>

          <Box w="100%">
            <FormLabel fontWeight="800" color="var(--text-primary)">
              Rejection reason
            </FormLabel>
            <Textarea
              {...textareaProps}
              placeholder="Write the reason…"
              onChange={(e) => setComment(e.target.value)}
              name="homework"
              id="homework"
            />
          </Box>

          <Box w="100%">
            <FormLabel fontWeight="800" color="var(--text-primary)">
              Assistant
            </FormLabel>
            <Select
              styles={modalSelectStyles}
              options={assistantsOptions}
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              menuPosition="fixed"
              onChange={(e) => {
                setAssistant(e.value);
                const el = document.getElementById("homework");
                if (el) {
                  el.value += "\n\n Reviewed by: " + e.sign;
                  setComment(el.value);
                }
              }}
              placeholder="Select assistant"
            />
          </Box>

          <Box w="100%">
            <FormLabel fontWeight="800" color="var(--text-primary)">
              Assistant notes
            </FormLabel>
            <Textarea
              id="assistantComment"
              {...textareaProps}
              placeholder="Write assistant notes…"
              onChange={(e) => setAssistantComment(e.target.value)}
              name="assistantComment"
            />
          </Box>
        </VStack>
      </MainModel>

      <HomeworkPdfAnnotator
        isOpen={annotatorOpen}
        onClose={() => setAnnotatorOpen(false)}
        filename={data?.file}
        onSave={setAnnotatedFile}
      />
    </>
  );
};

export default HomeworkRefuseComment;
